import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { IonContent, LoadingController, Platform } from '@ionic/angular';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GamesService } from 'src/app/services/lobby/games.service';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { LiveDealerService } from 'src/app/services/lobby/live-dealer.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { LobbyStateService } from 'src/app/services/lobbyState/lobby-state.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
    selector: 'app-tab-livedealer',
    templateUrl: 'tab-livedealer.page.html',
    styleUrls: ['tab-livedealer.page.scss']
})
export class TabLiveDealerPage implements OnInit, AfterViewInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;

    protected customerLevel: number = 0;
    private evoScriptAdded: boolean = false;
    public customer: CustomerModel;
    public iframeHeight = "100%";
    public isIOSApp: boolean = false;
    public isMobileApp: boolean;
    public isMobileWeb: boolean = false;
    public livedealer_url: any;
    public logoutLobbyTiles: any;
    public multipleLiveDealerAllGames: any;
    public liveDealerCategories: any;
    public multiLiveDealerVendorName: any;
    public multiLiveDealerVendorSpecificGames: any;
    public noLiveDealerGameData: boolean = false;
    public noSubCategoryLiveDealerGameData: boolean = false;
    public showIframe = false;
    public hasLiveDealerSubCategory: boolean = false;
    public isAuthenticated: boolean = false;
    public imagesPath: string;
    public favoriteKeywordsPayload: any;
    public superCategory: string = 'Live Dealer';
    public favouriteCategories: any;
    public netPosition = ['0.00'];
    public netWinOperator: string = "+";
    public dataToDisplay: string;
    public netPositionDelay: any;
    public netWinAmount:string = '0.00';
    public isNetPositionEnabled: boolean = false;
    public isSingleLiveDealerLobbyLoaded: boolean = false;
    public orientationSubscription: any;
    
    constructor(
        protected eventsService: EventsService,
        private keywordsService: KeywordsService,
        private lobbyState: LobbyStateService,
        public config: ConfigService,
        public loadingCtrl: LoadingController,
        public lobbyService: LobbyService,
        public platform: Platform,
        public gamesService: GamesService,
        public liveDealerService: LiveDealerService,
        public userSession: UserSessionService,
        public utils: UtilsService,
        public navigator: Navigator,
        private screenOrientation: ScreenOrientation
    ) {
        this.netPositionDelay = this.config.getConfig().FEATURE_NET_POSITION_DELAY || '0';
        this.isNetPositionEnabled = this.config.getConfig().FEATURE_SHOW_NET_POSITION_ON_LD ? (this.config.getConfig().FEATURE_SHOW_NET_POSITION_ON_LD === '1' ? true : false) : false;
        this.eventsService.subscribe('event:GameStats:Response', (data) => {
            console.log('-----received-------', data)
            this.dataToDisplay = data;
            let timeout = 0;
            if (this.netPositionDelay) {
                if (this.netPositionDelay == 0) {
                    timeout = 0;
                } else {
                    timeout = this.netPositionDelay * 1000;
                }
            }
            //configurable delay to display Net Position on UI
            setTimeout(() => {
                if (this.dataToDisplay.startsWith('-')) {
                    this.netWinOperator = "-";
                    this.netWinAmount = this.dataToDisplay.substring(1);
                } else {
                    this.netWinOperator = "+";
                    this.netWinAmount = this.dataToDisplay;
                }
                console.log('-----displaying-----', this.netWinAmount)
            }, timeout);
        });
    }

    ngOnInit(): void {
        this.checkForMobile();
        this.dispose();
        this.singleOrMultiple();
        this.verifyAuth();
    }

    ngAfterViewInit() {
        if (!this.hasLiveDealerSubCategory) {
            if (!this.evoScriptAdded) this.addEvoScripts();
        }
    }

    ionViewWillEnter() {
        if(!this.hasLiveDealerSubCategory) this.eventsService.publish("event:balanceState", { show: false, code: "IN_GAME" });
        //this.eventsService.publish("event:balanceState", { show: false, code: "IN_GAME" });
    }


    ionViewDidEnter() {
        this.orientationSubscription = this.screenOrientation.onChange().subscribe(() => {
            this.hideHeaderOnLandscape();
        });
        if (!this.isMobileWeb) {
            this.content.scrollToTop(10)
        }
    }

    public verifyAuth() {
        this.userSession.isAuthenticated().then((res) => {
            if (res) {
                this.isAuthenticated = true;
            }
        });
    }

    private singleOrMultiple(): any {
        this.favouriteCategories = this.liveDealerService.getLDFavouriteGameData();

        if (!isUndefined(this.favouriteCategories)) {
            this.showIframe = true;
            setTimeout(() => {
                //this.getMultipleLiveDealerLobby();
                this.launchSubCategoryLobby(this.favouriteCategories);
                return this.liveDealerService.setLDFavouriteGameData(undefined);
            }, 200);
        }

        //DeepLink logic for Multiple LD - specific category to launch
        if(this.lobbyService.getWaitingGameData()){
            setTimeout(() => {
                //this.getMultipleLiveDealerLobby();
                let multipleLDData = this.lobbyService.getWaitingGameData();
                if(multipleLDData[0]?.action_param)this.launchSubCategoryLobby(multipleLDData[0]);
                this.lobbyService.clearWaitingGameData();
            }, 200);
        }

        this.keywordsService.getLiveDealerSubCategory().subscribe((data) => {
            this.hasLiveDealerSubCategory = data;
            if (this.hasLiveDealerSubCategory) {
                return this.getMultipleLiveDealerLobby();
            }
            return this.getSingleLiveDealerLobby();
        });

    }

    private dispose(): void {
        const iframe = document.getElementById("live_casino_frame");
        if (iframe) iframe.remove();
        this.showIframe = false;
        this.livedealer_url = "";

        if (this.platform.is('ios') && this.platform.is('cordova')) {
            this.eventsService.publish("event:livedealerclosed");
        }
    }

    ionViewWillLeave() {
        this.dispose();
    }

    ionViewDidLeave() {
        this.orientationSubscription?.unsubscribe();
        this.eventsService.publish("event:balanceState", { show: true });
    }

    private getSingleLiveDealerLobby() {
        return this.userSession.isAuthenticated().then((res) => {
            if (res) {
                this.showIframe = true;
                let liveDealerCategory = "";

                let waitingGame = this.lobbyService.getWaitingGameData();
                if (!!waitingGame && 'extra_launch_data' in waitingGame) {
                    liveDealerCategory = waitingGame.extra_launch_data;
                    this.lobbyService.clearWaitingGameData();
                }
                return this.getSingleLDLobbyUrl(liveDealerCategory);
            }

            this.showIframe = false;
            this.livedealer_url = null;
            return this.getSingleLDLoggedOutgames();

        });

    }

    private getSingleLDLoggedOutgames(): any {
        this.showIframe = false;
        this.lobbyState.getCurrentKeywordSubject().subscribe(res => {
            if (res && res.gamesInfo?.length > 0) {
                this.noLiveDealerGameData = false;
                this.logoutLobbyTiles = res.gamesInfo;
                return;
            }
            this.noLiveDealerGameData = true;
            return;
        })
    }

    public getMultipleLiveDealerLobby() {
        return this.userSession.isAuthenticated().then((res) => {
            if (res) {

                const waitingGame = this.lobbyService.getWaitingGameData();
                if (!!waitingGame && 'extra_launch_data' in waitingGame) {
                    let liveDealerCategory =  waitingGame.extra_launch_data;
                    this.lobbyService.clearWaitingGameData();
                }
                return this.getLiveDealerSubKeywords();
            }
            this.showIframe = false;
            this.livedealer_url = null;
            return this.getLiveDealerSubKeywords();

        })
    }

    public getLiveDealerSubKeywords() {
        this.showIframe = false;
        this.hasLiveDealerSubCategory = true;
        this.lobbyState.getCurrentKeywordSubject().subscribe(res => {
            this.superCategory = res?.keyword;
            if (res && res.subKeywordsInfo?.length > 0) {
                this.noLiveDealerGameData = false;
                this.multipleLiveDealerAllGames = res?.gamesInfo;
                this.liveDealerCategories = res.subKeywordsInfo;
                return;
            }
            this.noLiveDealerGameData = true;
            return;
        })
    }


    private addEvoScripts() {
        if (this.platform.is('ios') && !this.platform.is('capacitor')) {
            this.evoScriptAdded = true;
            let evoHostname = this.config.getConfig().FEATURE_EVOLUTION_HOSTNAME;
            this.loadScriptPromise(evoHostname + "/frontend/evo/r2/js/iframe.js", "evo");
            setTimeout(() => {
                this.addScript(`
                EvolutionGaming.init({
                    iframeId: "live_casino_frame",
                    topBar: 70
                    });
                `, 'evo');
            }, 8000);
        }
    }

    private loadScriptPromise(src, id = "") {
        return new Promise(function (resolve, reject) {
            var s;
            s = document.createElement('script');
            s.src = src;
            s.onload = resolve;
            s.onerror = reject;
            if (!!id) s.id = id;
            document.head.appendChild(s);
        });
    }

    private addScript(js, id = "") {
        const script = document.createElement('script');
        script.innerHTML = js;
        if (!!id) script.id = id;
        document.head.appendChild(script);
    }

    private getSingleLDLobbyUrl(liveDealerCategory = 'blackjack', vendorName?) {
        this.launchWebLobby(liveDealerCategory, vendorName)
    }

    onScrollEnd(event) {
        if (!this.isMobileWeb) {
            let screenPosition = event ? event.scrollTop : 0;
            this.eventsService.publish("event:lobby:scroll", screenPosition);
        }
    }

    checkForMobile() {
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
        const mobileweb = mobile && !(this.platform.is('capacitor') || this.platform.is('cordova'));
        //this.isMobileWeb = this.platform.is('mobileweb') && !this.platform.is('capacitor');
        this.isMobileWeb = (mobile || mobileweb);
        this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
        this.isMobileApp = this.platform.is("capacitor");
    }

    hideHeaderOnLandscape() {
        if(this.isMobileWeb && this.screenOrientation.type.includes('landscape')){
            this.eventsService.publish("event:siteheader:hide");
        }else{
            this.eventsService.publish("event:siteheader:show");
        }
    }

    goToCasino() {
        this.eventsService.publish("event:siteheader:show");
        const firstTopKeyword = this.lobbyState.getFirstTopKeyword();
        if(firstTopKeyword){
            this.eventsService.publish("searchbar:keyword:click", firstTopKeyword);
        }
        this.navigator.toCasino();
    }

    public showSubCategoryGames(data: any): void {
        const vendorName = data?.action_param;
        let parsedVendorName;
        try {
            parsedVendorName = JSON.parse(vendorName);
        } catch (error) {
            console.error("Error parsing vendorName:", error);
            this.noSubCategoryLiveDealerGameData = false;
            return;
        }

        const vendor = parsedVendorName?.vendor;
        if (!vendor) {
            this.noSubCategoryLiveDealerGameData = false;
            return;
        }

        this.multiLiveDealerVendorName = vendor;
        const vendorSpecificGames = this.multipleLiveDealerAllGames[data?.name];
        this.multiLiveDealerVendorSpecificGames = vendorSpecificGames;
        this.noSubCategoryLiveDealerGameData = !(this.multiLiveDealerVendorSpecificGames?.length > 0);
    }

    public launchSubCategoryLobby(data: any): void {
        this.eventsService.publish("event:balanceState", { show: false, code: "IN_GAME" });
        const vendorName = data?.action_param;
        this.multiLiveDealerVendorName = JSON.parse(vendorName)
        this.multiLiveDealerVendorName = this.multiLiveDealerVendorName.vendor;

        if (this.multiLiveDealerVendorName && !isUndefined(this.multiLiveDealerVendorName)) {
            this.showIframe = true;
            this.getSingleLDLobbyUrl('', this.multiLiveDealerVendorName);
        }
    }

    onLogin(gameData) {
      if (gameData.super_type === "LIVE_DEALER") {
        localStorage.setItem('skipActiveBonusCheck', 'true');
      }
        this.lobbyService.setWaitingGameData(gameData);
    }

    protected selectedTileId: any = null;
    protected handleTileSelection(tileData: any): any {
        // Toggle selection if the same item is clicked; otherwise, update to the new item
        if (this.selectedTileId === tileData.id) {
            this.selectedTileId = null;
        } else {
            this.selectedTileId = tileData.id;
        }
    }

    launchWebLobby(liveDealerCategory, vendorName?) {
        let liveDealerCategoryLaunch = this.config.getConfig().FEATURE_USE_DEFAULT_LIVEDEALER_CATEGORY_LAUNCH ? this.config.getConfig().FEATURE_USE_DEFAULT_LIVEDEALER_CATEGORY_LAUNCH : liveDealerCategory; 
        return this.lobbyService.getLiveDealerUrl(this.isMobileApp, liveDealerCategoryLaunch, vendorName).subscribe(response => {
            if (response.result == 1) {
                if ('href' in response.payload) {
                    this.livedealer_url = response.payload.href;
                    this.isSingleLiveDealerLobbyLoaded = true;
                    if(this.isMobileWeb && this.platform.isLandscape()){
                        this.eventsService.publish("event:siteheader:hide");
                    }
                }
            }
        });
    }

}
